module.exports = __webpack_public_path__ + "img/nigiri-various.8b46c7fd.png";